const Rails = require('@rails/ujs')

global.SubmitOnChange = function(element) {
  element.change(function() {
    var form = element[0]
    Rails.fire(form, "submit")
  });
};